import { render } from "./base-icon.vue?vue&type=template&id=11c55393"
import script from "./base-icon.vue?vue&type=script&lang=ts"
export * from "./base-icon.vue?vue&type=script&lang=ts"
script.render = render

export default script